module.exports = "https://cdn.dove.it/_next/static/public/assets/about-us.49885b6a4ad95bd39a4f02380045646a.png";